package br.com.texeratx.boardgametimeapp.ui.screens.games.model

data class GameUI(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val minPlayers: Int?,
    val maxPlayers: Int?,
    val duration: Int?,
    val categoryId: Long?,
    val category: String?,
    val modeId: Long?,
    val mode: String?,
    val bggUrl: String?,
    val manualUrl: String?,
    val spotifyUrl: String?,
    val matchesPlayed: Int,
    val clanId: Long
)


